import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Modal from 'components/Modal';
import Breakpoints from 'lib/Breakpoints';

import styles from './CardOverlay.module.scss';

export default class CardOverlay extends React.Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    isActive: PropTypes.bool,
    useModal: PropTypes.bool,
    additionalClasses: PropTypes.shape({ border: PropTypes.string, container: PropTypes.string }),
    activeOnHover: PropTypes.bool,
  };

  static contextTypes = {
    vertical: PropTypes.string,
  };

  static defaultProps = {
    children: null,
    useModal: false,
    additionalClasses: {
      border: '',
      container: '',
    },
    activeOnHover: false,
    isActive: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      isListening: false,
    };
  }

  componentDidUpdate() {
    const { isActive } = this.props;
    const { isListening } = this.state;
    if (isActive && !isListening) {
      Breakpoints.getSmallMQL().addListener(this.breakpointListener);
      this.setState({ isListening: true }); // eslint-disable-line react/no-did-update-set-state
    }
    if (!isActive && isListening) {
      Breakpoints.getSmallMQL().removeListener(this.breakpointListener);
      this.setState({ isListening: false }); // eslint-disable-line react/no-did-update-set-state
    }
  }

  componentWillUnmount() {
    const { isListening } = this.state;
    if (isListening) {
      Breakpoints.getSmallMQL().removeListener(this.breakpointListener);
    }
  }

  breakpointListener = () => {
    this.forceUpdate();
  }

  render() {
    const isSmallBreakpoint = Breakpoints.isS();
    const {
      children, isActive, useModal, additionalClasses, activeOnHover,
    } = this.props;
    const {
      border: borderColorOverride,
      container: additionalContainerClasses,
    } = additionalClasses;
    const { vertical } = this.context;

    let borderColor = '';
    if (['news', 'globalcitizen', 'leftfield'].includes(vertical)) {
      borderColor = 'b-secondary';
    } else if (vertical !== 'today') {
      borderColor = 'b-primary';
    }

    if (borderColorOverride) {
      borderColor = borderColorOverride;
    }

    const sharedClasses = [
      styles.overlayContainer,
      borderColor,
      'bg-white',
      additionalContainerClasses,
    ];

    if (isSmallBreakpoint) {
      return isActive && useModal
        ? (
          <Modal preventBackgroundScroll>
            <div
              className={cx(
                sharedClasses,
                'fixed top0 left0 w-100 h-100 z-5',
              )}
            >
              {children}
            </div>
          </Modal>
        )
        : null;
    }
    return (
      <div
        className={cx(
          sharedClasses,
          'absolute absolute-fill z-1',
          styles.overlayContainerAbsolute,
          {
            cardOverlayHover: activeOnHover,
            [styles.active]: isActive,
          },
        )}
      >
        {children}
      </div>
    );
  }
}
